import styled from '@emotion/styled';

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1)};
  margin-bottom: ${({ theme }) => theme.spacing(4)};

  &:last-child {
    margin-bottom: 0;
  }
`;

export const Label = styled.label`
  font-size: ${({ theme }) => theme.font.size.sm};
  font-weight: ${({ theme }) => theme.font.weight.medium};
  color: ${({ theme }) => theme.font.color.primary};
`;

const inputStyles = ({ theme }) => `
  width: 100%;
  height: 32px; /* Fixed from 36px */
  padding: 0 ${theme.spacing(3)};
  font-size: ${theme.font.size.sm};
  font-family: ${theme.font.family};
  color: ${theme.font.color.primary};
  background: ${theme.background.secondary};
  border: 1px solid ${theme.border.color.medium};
  border-radius: ${theme.border.radius.sm};
  transition: ${theme.animation.transition.standard};
  box-sizing: border-box;

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: none;
    border-color: ${theme.accent.primary};
    box-shadow: ${theme.focusShadow(theme.accent.tertiary)};
  }

  &::placeholder {
    color: ${theme.font.color.light};
  }

  &:disabled {
    background: ${theme.background.tertiary};
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const Input = styled.input`
  ${({ theme }) => inputStyles({ theme })}
`;

export const Select = styled.select`
  ${({ theme }) => inputStyles({ theme })}
  cursor: pointer;
`;

export const TextArea = styled.textarea`
  ${({ theme }) => inputStyles({ theme })}
  height: auto;
  min-height: 80px;
  padding: ${({ theme }) => theme.spacing(2, 3)};
  resize: vertical;
`;

export const HelperText = styled.small`
  font-size: ${({ theme }) => theme.font.size.xs};
  color: ${({ theme }) => theme.font.color.tertiary};
`;

export const ErrorAlert = styled.div`
  padding: ${({ theme }) => theme.spacing(2, 3)};
  background: ${({ theme }) => theme.background.danger};
  border: 1px solid ${({ theme }) => theme.border.color.danger};
  border-radius: ${({ theme }) => theme.border.radius.sm};
  color: ${({ theme }) => theme.font.color.danger};
  font-size: ${({ theme }) => theme.font.size.sm};
  margin-bottom: ${({ theme }) => theme.spacing(4)};
`;

export const FormSectionTitle = styled.h3`
  font-size: ${({ theme }) => theme.font.size.md};
  font-weight: ${({ theme }) => theme.font.weight.semiBold};
  color: ${({ theme }) => theme.font.color.primary};
  margin: ${({ theme }) => theme.spacing(5, 0, 3, 0)};
`;
